import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'categoryfilter',
    pure: false
})
export class CategoryFilterPipe implements PipeTransform {
  transform(items, filter) {
    if (!items || !filter) {
      return items;
    }
    // filter items array, items which match and return true will be kept, false will be filtered out
    return items.filter(e => e["codysub"].includes(filter))[0]["detalle"]
  }
}